import { render } from "./HighlightedComment.vue?vue&type=template&id=bea7ec16"
import script from "./HighlightedComment.vue?vue&type=script&lang=js"
export * from "./HighlightedComment.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__